import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { AvatarGroupSize, AvatarGroup } from '..';
import { classes } from './AvatarGroup.visual.st.css';

const IMG_SRC =
  'https://upload.wikimedia.org/wikipedia/commons/6/62/Solid_red.svg';

function generate3Items() {
  return [
    {},
    { name: 'anonymous' },
    {
      name: 'Eve',
      src: IMG_SRC,
      onLoad: true,
    },
  ];
}

const AvatarGroupAsync = ({
  onDone,
  withText = false,
  items,
  maxAmount = 0,
  textButtonDisabled = false,
  ...rest
}) => {
  const numberOfLoadsToWait = React.useRef(0); // items.filter(item => item.onLoad).length;
  const loadCount = React.useRef(0);
  const maxLoadCount = maxAmount || 5;

  const onLoad = () => {
    if (loadCount.current === numberOfLoadsToWait.current - 1) {
      setTimeout(onDone, 500);
    } else {
      loadCount.current += 1;
    }
  };

  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (item.onLoad) {
      item.onLoad = onLoad;

      if (i < maxLoadCount) {
        numberOfLoadsToWait.current += 1;
      }
    }
  }

  return (
    <AvatarGroup {...rest} items={items} maxAmount={maxAmount || undefined}>
      {withText ? (
        <AvatarGroup.TextButton disabled={textButtonDisabled}>Click me</AvatarGroup.TextButton>
      ) : null}
    </AvatarGroup>
  );
};

visualize('AvatarGroup', () => {
  Object.keys(AvatarGroupSize).forEach((avatarGroupSize) => {
    const size = AvatarGroupSize[avatarGroupSize];

    story(`size: ${avatarGroupSize}`, () => {
      snap('Empty', <AvatarGroup size={size} />);

      snap('With 3 items and default limit', (done) => (
        <AvatarGroupAsync size={size} items={generate3Items()} onDone={done} />
      ));

      snap('With 6 items and default limit', (done) => {
        return (
          <AvatarGroupAsync
            size={size}
            items={[...generate3Items(), ...generate3Items()]}
            onDone={done}
          />
        );
      });

      snap('With 12 items and custom limit', (done) => {
        return (
          <AvatarGroupAsync
            maxAmount={9}
            size={size}
            items={[
              ...generate3Items(),
              ...generate3Items(),
              ...generate3Items(),
              ...generate3Items(),
            ]}
            onDone={done}
          />
        );
      });

      snap('With optional text link', (done) => (
        <AvatarGroupAsync
          size={size}
          items={generate3Items()}
          onDone={done}
          withText
        />
      ));

      snap('RTL', (done) => (
        <div dir="rtl">
          <AvatarGroupAsync
            size={size}
            items={generate3Items()}
            onDone={done}
            withText
          />
        </div>
      ));
    });
  });

  story('Style Overrides', () => {
    snap('Avatar border color', (done) => (
      <AvatarGroupAsync
        size={AvatarGroupSize.medium}
        items={generate3Items()}
        onDone={done}
        withText
        className={classes.avatarBorderColor}
      />
    ));

    snap('Text button color', (done) => (
      <AvatarGroupAsync
        size={AvatarGroupSize.medium}
        items={generate3Items()}
        onDone={done}
        withText
        className={classes.textButtonColor}
      />
    ));

    snap('Text button font', (done) => (
      <AvatarGroupAsync
        size={AvatarGroupSize.medium}
        items={generate3Items()}
        onDone={done}
        withText
        className={classes.textButtonFont}
      />
    ));
  });
  story('Wst Style Overrides', () => {
    snap('enabled', (done) => (
      <AvatarGroupAsync
        size={AvatarGroupSize.medium}
        items={generate3Items()}
        onDone={done}
        withText
        className={classes.wstOverride}
      />
    ));

    snap('disabled', (done) => (
      <AvatarGroupAsync
        size={AvatarGroupSize.medium}
        items={generate3Items()}
        onDone={done}
        withText
        textButtonDisabled
        className={classes.wstOverride}
      />
    ));
  });
});
